import { CalendarDays } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatINR } from "@/data/tours";

// Lets a visitor pick one departure; the PDF, email and WhatsApp summary use it.
export const DeparturePicker = ({ tour, value, onChange }) => {
  if (!tour.dates?.length) {
    return (
      <div className="flex items-center gap-2 text-[12.5px] text-gray-500" data-testid="departure-picker-empty">
        <CalendarDays className="w-4 h-4 text-[var(--yellow-2)]" /> Departure dates on request
      </div>
    );
  }
  return (
    <div data-testid="departure-picker">
      <div className="text-[11px] uppercase tracking-wider font-semibold text-gray-500 mb-1.5">Choose your departure</div>
      <Select value={value?.date || ""} onValueChange={(d) => onChange(tour.dates.find((x) => x.date === d))}>
        <SelectTrigger className="h-11 text-[13.5px] font-semibold text-[var(--navy)]" data-testid="departure-select">
          <CalendarDays className="w-4 h-4 text-[var(--yellow-2)] mr-1 shrink-0" />
          <SelectValue placeholder="Select a departure date" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {tour.dates.map((d, i) => (
            <SelectItem key={d.date} value={d.date} data-testid={`departure-option-${i}`} className="text-[13px]">
              {d.date} · {formatINR(d.price ?? tour.startingPrice)}{d.tag && d.tag !== "Available departure" ? ` · ${d.tag}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
